export interface SchoolState {
  initial: any;
  salesToken: SalesToken | null
}

export interface SalesToken {
  id: number
  admin_id: number
  school_package_id: number
  module: SalesTokenModuleEnum
  token: string
  status: number
  is_active: boolean
  created_at: string
  updated_at: string
  deleted_at: string | null
  admin: {
    id: number
    name: string
    email: string
    email_verified_at: string | null
    created_at: string
    updated_at: string
    deleted_at: string | null
  }
}

export enum SalesTokenStatusEnum {
  NOT_USED = 1,
  CLAIMED = 2,
}
export enum SalesTokenModuleEnum {
  SCHOOL = 1,
  JOBFAIR = 2,
}